"use client"

import { Button } from "./components/ui/button"
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "./components/ui/card"
import { Checkbox } from "./components/ui/checkbox"
import { Input } from "./components/ui/input"
import { Label } from "./components/ui/label"
import { RadioGroup, RadioGroupItem } from "./components/ui/radio-group"
import { Textarea } from "./components/ui/textarea"

const plans = [
  {
    id: "starter",
    name: "스타터 플랜",
    description: "소규모 비즈니스에 적합합니다.",
    price: "₩10,000",
  },
  {
    id: "pro",
    name: "프로 플랜",
    description: "더 많은 기능과 저장 공간을 제공합니다.",
    price: "₩20,000",
  },
] as const

export function CardsForms() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">구독 업그레이드</CardTitle>
        <CardDescription className="text-balance">
          현재 무료 플랜을 사용 중입니다. 프로 플랜으로 업그레이드하여 모든 기능을 이용하세요.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-3 md:flex-row">
            <div className="flex flex-1 flex-col gap-2">
              <Label htmlFor="name">이름</Label>
              <Input id="name" placeholder="홍길동" />
            </div>
            <div className="flex flex-1 flex-col gap-2">
              <Label htmlFor="email">이메일</Label>
              <Input id="email" placeholder="example@company.com" />
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <Label htmlFor="card-number">카드 번호</Label>
            <div className="grid grid-cols-2 gap-3 md:grid-cols-[1fr_80px_60px]">
              <Input id="card-number" placeholder="1234 1234 1234 1234" className="col-span-2 md:col-span-1" />
              <Input id="card-number-expiry" placeholder="MM/YY" />
              <Input id="card-number-cvc" placeholder="CVC" />
            </div>
          </div>
          <fieldset className="flex flex-col gap-3">
            <legend className="text-sm font-medium">플랜</legend>
            <p className="text-muted-foreground text-sm">필요에 가장 적합한 플랜을 선택하세요.</p>
            <RadioGroup defaultValue="starter" className="grid gap-3 md:grid-cols-2">
              {plans.map((plan) => (
                <Label
                  className="has-[[data-state=checked]]:border-ring has-[[data-state=checked]]:bg-primary/10 flex items-start gap-3 rounded-lg border p-3"
                  key={plan.id}
                >
                  <RadioGroupItem value={plan.id} id={plan.name} className="data-[state=checked]:border-primary" />
                  <div className="grid gap-1 font-normal">
                    <div className="font-medium">{plan.name}</div>
                    <div className="text-muted-foreground text-xs leading-snug text-balance">{plan.description}</div>
                  </div>
                </Label>
              ))}
            </RadioGroup>
          </fieldset>
          <div className="flex flex-col gap-2">
            <Label htmlFor="notes">메모</Label>
            <Textarea id="notes" placeholder="메모를 입력하세요" />
          </div>
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-2">
              <Checkbox id="terms" />
              <Label htmlFor="terms" className="font-normal">
                이용약관에 동의합니다
              </Label>
            </div>
            <div className="flex items-center gap-2">
              <Checkbox id="newsletter" defaultChecked />
              <Label htmlFor="newsletter" className="font-normal">
                이메일 수신에 동의합니다
              </Label>
            </div>
          </div>
        </div>
      </CardContent>
      <CardFooter className="flex justify-between">
        <Button variant="outline" size="sm">
          취소
        </Button>
        <Button size="sm">플랜 업그레이드</Button>
      </CardFooter>
    </Card>
  )
}
